var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trend"},_vm._l((_vm.value),function(v,index){return _c('div',{key:index,staticClass:"trend-item",style:(_vm.styleItem(v))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }